import React from 'react';
import { LoaderCard, Wrapper } from './styles';

interface LoadingCardsProps {
    width: number;
    itemWidth: number;
}

const LoadingCards: React.FunctionComponent<LoadingCardsProps> = ({ width, itemWidth }) => {
    const loaderCards = [];
    for (let i = 0; i < Math.floor(width / itemWidth); i++) {
        loaderCards.push(<LoaderCard key={`${i}_loaderCard`} itemWidth={itemWidth} />);
    }

    return (
        <Wrapper>
            {loaderCards}
        </Wrapper>)
}

export default LoadingCards;
